/**
 * Normalizes the reservable-space weekday payload returned by old and new API
 * clients. Values may arrive as decoded arrays, JSON strings, or legacy
 * PostgreSQL array literals.
 */
export function normalizeAvailableDays(value: unknown): number[] {
  let candidate = value;

  if (typeof candidate === 'string') {
    try {
      candidate = JSON.parse(candidate);
    } catch {
      const postgresArray = candidate.match(/^\{(.*)\}$/);
      if (!postgresArray) {
        return [];
      }
      candidate = postgresArray[1] ? postgresArray[1].split(',').map((day) => day.replace(/^"|"$/g, '')) : [];
    }
  }

  if (!Array.isArray(candidate)) {
    return [];
  }

  return candidate.map((day) => Number(day)).filter((day) => Number.isInteger(day) && day >= 1 && day <= 7);
}
